// tslint:disable
/**
 * Reservation Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AvailabilitySyncRequest } from '../models';
import { GetAvailableRatesByReservationRequest } from '../models';
import { GetAvailableRatesByReservationResponse } from '../models';
import { GetAvailableRatesRequest } from '../models';
import { GetAvailableRatesResponse } from '../models';
import { GetBulkAvailableRatesByReservationRequest } from '../models';
import { GetBulkAvailableRatesByReservationResponse } from '../models';
/**
 * AvailabilityApi - axios parameter creator
 * @export
 */
export const AvailabilityApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {GetAvailableRatesRequest} [getAvailableRatesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesPost(
      getAvailableRatesRequest?: GetAvailableRatesRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/availability/rates`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof getAvailableRatesRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(getAvailableRatesRequest !== undefined ? getAvailableRatesRequest : {})
        : getAvailableRatesRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetBulkAvailableRatesByReservationRequest} [getBulkAvailableRatesByReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesReservationBulkPost(
      getBulkAvailableRatesByReservationRequest?: GetBulkAvailableRatesByReservationRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/availability/rates/reservation/bulk`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof getBulkAvailableRatesByReservationRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            getBulkAvailableRatesByReservationRequest !== undefined
              ? getBulkAvailableRatesByReservationRequest
              : {}
          )
        : getBulkAvailableRatesByReservationRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetAvailableRatesByReservationRequest} [getAvailableRatesByReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesReservationPost(
      getAvailableRatesByReservationRequest?: GetAvailableRatesByReservationRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/availability/rates/reservation`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof getAvailableRatesByReservationRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            getAvailableRatesByReservationRequest !== undefined
              ? getAvailableRatesByReservationRequest
              : {}
          )
        : getAvailableRatesByReservationRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilitySyncInventoryPost(
      availabilitySyncRequest?: AvailabilitySyncRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/availability/sync/inventory`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof availabilitySyncRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(availabilitySyncRequest !== undefined ? availabilitySyncRequest : {})
        : availabilitySyncRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilitySyncRatesPost(
      availabilitySyncRequest?: AvailabilitySyncRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/availability/sync/rates`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof availabilitySyncRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(availabilitySyncRequest !== undefined ? availabilitySyncRequest : {})
        : availabilitySyncRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AvailabilityApi - functional programming interface
 * @export
 */
export const AvailabilityApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {GetAvailableRatesRequest} [getAvailableRatesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesPost(
      getAvailableRatesRequest?: GetAvailableRatesRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailableRatesResponse> {
      const localVarAxiosArgs = AvailabilityApiAxiosParamCreator(
        configuration
      ).availabilityRatesPost(getAvailableRatesRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {GetBulkAvailableRatesByReservationRequest} [getBulkAvailableRatesByReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesReservationBulkPost(
      getBulkAvailableRatesByReservationRequest?: GetBulkAvailableRatesByReservationRequest,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<GetBulkAvailableRatesByReservationResponse> {
      const localVarAxiosArgs = AvailabilityApiAxiosParamCreator(
        configuration
      ).availabilityRatesReservationBulkPost(getBulkAvailableRatesByReservationRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {GetAvailableRatesByReservationRequest} [getAvailableRatesByReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesReservationPost(
      getAvailableRatesByReservationRequest?: GetAvailableRatesByReservationRequest,
      options?: any
    ): (
      axios?: AxiosInstance,
      basePath?: string
    ) => AxiosPromise<GetAvailableRatesByReservationResponse> {
      const localVarAxiosArgs = AvailabilityApiAxiosParamCreator(
        configuration
      ).availabilityRatesReservationPost(getAvailableRatesByReservationRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilitySyncInventoryPost(
      availabilitySyncRequest?: AvailabilitySyncRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = AvailabilityApiAxiosParamCreator(
        configuration
      ).availabilitySyncInventoryPost(availabilitySyncRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilitySyncRatesPost(
      availabilitySyncRequest?: AvailabilitySyncRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = AvailabilityApiAxiosParamCreator(
        configuration
      ).availabilitySyncRatesPost(availabilitySyncRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AvailabilityApi - factory interface
 * @export
 */
export const AvailabilityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {GetAvailableRatesRequest} [getAvailableRatesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesPost(
      getAvailableRatesRequest?: GetAvailableRatesRequest,
      options?: any
    ): AxiosPromise<GetAvailableRatesResponse> {
      return AvailabilityApiFp(configuration).availabilityRatesPost(
        getAvailableRatesRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {GetBulkAvailableRatesByReservationRequest} [getBulkAvailableRatesByReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesReservationBulkPost(
      getBulkAvailableRatesByReservationRequest?: GetBulkAvailableRatesByReservationRequest,
      options?: any
    ): AxiosPromise<GetBulkAvailableRatesByReservationResponse> {
      return AvailabilityApiFp(configuration).availabilityRatesReservationBulkPost(
        getBulkAvailableRatesByReservationRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {GetAvailableRatesByReservationRequest} [getAvailableRatesByReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilityRatesReservationPost(
      getAvailableRatesByReservationRequest?: GetAvailableRatesByReservationRequest,
      options?: any
    ): AxiosPromise<GetAvailableRatesByReservationResponse> {
      return AvailabilityApiFp(configuration).availabilityRatesReservationPost(
        getAvailableRatesByReservationRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilitySyncInventoryPost(
      availabilitySyncRequest?: AvailabilitySyncRequest,
      options?: any
    ): AxiosPromise<void> {
      return AvailabilityApiFp(configuration).availabilitySyncInventoryPost(
        availabilitySyncRequest,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    availabilitySyncRatesPost(
      availabilitySyncRequest?: AvailabilitySyncRequest,
      options?: any
    ): AxiosPromise<void> {
      return AvailabilityApiFp(configuration).availabilitySyncRatesPost(
        availabilitySyncRequest,
        options
      )(axios, basePath);
    },
  };
};

/**
 * AvailabilityApi - object-oriented interface
 * @export
 * @class AvailabilityApi
 * @extends {BaseAPI}
 */
export class AvailabilityApi extends BaseAPI {
  /**
   *
   * @param {GetAvailableRatesRequest} [getAvailableRatesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public availabilityRatesPost(getAvailableRatesRequest?: GetAvailableRatesRequest, options?: any) {
    return AvailabilityApiFp(this.configuration).availabilityRatesPost(
      getAvailableRatesRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {GetBulkAvailableRatesByReservationRequest} [getBulkAvailableRatesByReservationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public availabilityRatesReservationBulkPost(
    getBulkAvailableRatesByReservationRequest?: GetBulkAvailableRatesByReservationRequest,
    options?: any
  ) {
    return AvailabilityApiFp(this.configuration).availabilityRatesReservationBulkPost(
      getBulkAvailableRatesByReservationRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {GetAvailableRatesByReservationRequest} [getAvailableRatesByReservationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public availabilityRatesReservationPost(
    getAvailableRatesByReservationRequest?: GetAvailableRatesByReservationRequest,
    options?: any
  ) {
    return AvailabilityApiFp(this.configuration).availabilityRatesReservationPost(
      getAvailableRatesByReservationRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public availabilitySyncInventoryPost(
    availabilitySyncRequest?: AvailabilitySyncRequest,
    options?: any
  ) {
    return AvailabilityApiFp(this.configuration).availabilitySyncInventoryPost(
      availabilitySyncRequest,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {AvailabilitySyncRequest} [availabilitySyncRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public availabilitySyncRatesPost(
    availabilitySyncRequest?: AvailabilitySyncRequest,
    options?: any
  ) {
    return AvailabilityApiFp(this.configuration).availabilitySyncRatesPost(
      availabilitySyncRequest,
      options
    )(this.axios, this.basePath);
  }
}
